import { GrantTypeEnum } from '../../account.data';
import { CONTENT_TYPE_HEADER } from 'i2g-ng-utils';

/*** HTTP keys ***/
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const CREATE_FLAG_KEY = 'createFlag';
export const CLIENT_ID = 'EDB34FDB-FE26-477C-BC62-30C7C42EEDF6';
export const CLIENT_SECRET = 'daniel2go';

/*** HTTP headers ***/
export const ACCEPT_VERSION_HEADER = 'x-i2g-accept-version';
export const LOCALE_HEADER = 'x-i2g-locale';
export const CLIENT_HEADER = 'x-i2g-client';

export interface IAccountLoginRequestHeaders {
  [CONTENT_TYPE_HEADER]: string;
  [ACCEPT_VERSION_HEADER]: string;
  [CLIENT_HEADER]: string;
  [LOCALE_HEADER]: string;
}

/*** interfaces ***/
export interface IReferringCompanyRequestQueryParameter {
  referral: string;
}

export interface IAccountRegistrationRequest {
  email: string;
  grantType: GrantTypeEnum;
  locale: string;
  referralCode?: string;
  token: string;
}

export interface IAccountRegistrationRequestPayload {
  client_id: string;
  client_secret: string;
  company_name?: string;
  country?: string;
  email: string;
  grant_type: GrantTypeEnum;
  locale: string;
  referral_code?: string;
  scope?: string;
  token: string;
}

export interface IAccountLoginRequest {
  email: string;
  grantType: GrantTypeEnum;
  token: string;
  locale: string;
}

export interface IAccountLoginRequestPayload {
  client_id: string;
  client_secret: string;
  company_name?: string;
  country?: string;
  username?: string;
  grant_type: GrantTypeEnum;
  scope?: string;
  password?: string;
  token?: string;
  sign_up?: boolean;
  challenge_id?: string;
}

export interface ICompanyLoginRequestPayload {
  client_id: string;
  client_secret: string;
  grant_type: GrantTypeEnum;
  account_id: string;
  refresh_token: string;
}

export interface ISetPasswordRequestPayload {
  email: string;
  locale: string;
}

export interface ISetPasswordTokenRequestPayload {
  token: string;
  locale: string;
}

export interface IUpdatePasswordRequestPayload
  extends ISetPasswordTokenRequestPayload {
  user_id: string;
  new_password: string;
}

export interface IChangePasswordTokenRequestPayload {
  token: string;
  locale: string;
}
